export default "__VITE_ASSET__Cl1JuwdT__"